'use client'

import { Auth } from 'aws-amplify'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

const Body = () => {
  const router = useRouter()

  useEffect(() => {
    ;(async () => {
      await Auth.signOut()
      router.replace('/')
    })()
  }, [router])

  return <>Logging out...</>
}

export default Body
